import { FactionType, FrontlinePage } from '../models/frontlines-types'

import sitemap, { pirateSiteMap } from '../sitemap/frontlines-sitemap'

export const getFaction = (faction: FactionType): FrontlinePage => {
    return sitemap.concat(pirateSiteMap).find((page) => page.faction === faction)
}